
import {Property} from "./property";

export class SubauthorityData{
  signingUrl: string;
  signingDate: string;
  interest: string;
  properties: Array<Property>;
  date: string;
  gesellschaft: string;
  company: string;
  person: string;
  dauer: string;


  constructor(signingUrl: string, signingDate: string, date: string, gesellschaft: string, company: string, person: string,dauer: string,interest: string, properties: Array<Property>) {
    this.signingUrl = signingUrl;
    this.signingDate = signingDate;
    this.interest = interest;
    this.properties = properties;
    this.date = date;
    this.gesellschaft = gesellschaft;
    this.company = company;
    this.person = person;
    this.dauer = dauer;
  }
}

